import { gql } from '@apollo/client'
import { Heading, Subtitle } from '@farol-ds/react'
import { OfferLockCard } from '@jusbrasil-web/shared-apollo-client/types'

import { AiTwoOfferPlanCard } from '../ai-two-offer-plan-card'
import {
  AiTwoOffersLockContent_OfferLockDataFragment,
  AiTwoOffersLockContent_ViewerFragment,
} from './__generated__/ai-two-offers-lock-content.graphql'
import styles from './ai-two-offers-lock.module.scss'

export interface AiTwoOffersLockContentProps {
  offerLockData: AiTwoOffersLockContent_OfferLockDataFragment
  viewer: AiTwoOffersLockContent_ViewerFragment
}

export function AiTwoOffersLockContent({ offerLockData, viewer }: AiTwoOffersLockContentProps) {
  const { header } = offerLockData
  const { title = '', subtitle = '' } = header
  const { body } = offerLockData || {}
  const { cards } = body || {}

  const isYearlyAndHasCreditCard = (card: OfferLockCard) =>
    !!card.offer.installmentsText && !!card.creditCard

  return (
    <>
      <Heading className={styles['ai-two-offers-lock-title']} size="lg" asChild>
        <h3>{title}</h3>
      </Heading>
      <Subtitle className={styles['ai-two-offers-lock-subtitle']} asChild>
        <p dangerouslySetInnerHTML={{ __html: subtitle }} />
      </Subtitle>
      <div className={styles['ai-two-offers-lock-cards']}>
        {cards.map((card, index) => (
          <AiTwoOfferPlanCard
            offerLockCard={card}
            viewer={viewer}
            key={`plan-offer-card-${index}`}
            className={styles['ai-two-offers-lock-cards-card']}
            showCreditCardAndRemoveOneClick={isYearlyAndHasCreditCard(card as OfferLockCard)}
          />
        ))}
      </div>
    </>
  )
}

AiTwoOffersLockContent.fragments = {
  offerLockData: gql`
    fragment AiTwoOffersLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          creditCard {
            ccToken
            lastDigits
            brandName
          }
          offer {
            installmentsText
          }
          ...AiTwoOfferPlanCard_offerLockCard
        }
      }
    }
    ${AiTwoOfferPlanCard.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment AiTwoOffersLockContent_viewer on Profile {
      ...AiTwoOfferPlanCard_viewer
    }
    ${AiTwoOfferPlanCard.fragments.viewer}
  `,
}
